import { FC, useEffect, useState } from 'react';
import { useContextSelector } from 'use-context-selector';

import { createContactWithEmail } from '@/core/apis/content-apis';
import { setNotificationAction } from '@/core/store/global/app-view-reducers';
import { AppContext, setAppState } from '@/core/store/global/AppProvider';
import { isValidEmail } from '@/core/utils/helpers';

type CreateContactProps = {
  onClose: () => void;
  response?: (response: any) => void;
};

const CreateContact: FC<CreateContactProps> = ({ onClose, response = () => {} }) => {
  const [name, setName] = useState<string>('');
  const [email, setEmail] = useState<string>('');
  const [isValid, setIsValid] = useState<boolean>(false);
  const [isCreating, setIsCreating] = useState<boolean>(false);
  const dispatch = useContextSelector(AppContext, setAppState);

  useEffect(() => {
    setIsValid(isValidEmail(email) && name != '');
  }, [name, email]);

  const onSubmit = () => {
    setIsCreating(true);
    createContactWithEmail({ contacts: [{ name, email }], type: 'USER' })
      .then((res) => {
        dispatch(
          setNotificationAction({
            notification: {
              show: true,
              message: 'Contact created successfully.',
              variant: 'success',
            },
          }),
        );
        response(res);
        onClose();
      })
      .catch((error) => {
        dispatch(
          setNotificationAction({
            notification: {
              show: true,
              message: 'Failed to create contact',
              variant: 'error',
            },
          }),
        );
        onClose();
      });
  };

  return (
    <div className="w-full h-full flex flex-col gap-y-2 p-2">
      <div className="font-bold text-slate-800 text-xl">Create Contact</div>
      <div className="w-full h-full flex flex-col gap-y-2 p-1">
        <div>Name</div>
        <input
          type="text"
          className="border border-gray-300 bg-gray-100 p-2 rounded-md text-gray-900 w-full text-[15px] focus:ring-2 focus:ring-inset focus:outline-none focus:ring-black"
          placeholder="Name"
          value={name}
          onChange={(e) => setName(e.target.value)}
        ></input>
        <div>Email</div>
        <input
          type="email"
          className="border border-gray-300 bg-gray-100 p-2 rounded-md text-gray-900 w-full text-[15px] focus:ring-2 focus:ring-inset focus:outline-none focus:ring-black"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        ></input>
      </div>

      <button
        className={`rounded-full py-2 ${
          isValid ? 'bg-black pointer-events-auto ' : 'bg-slate-600 pointer-events-none cursor-not-allowed'
        } text-white font-bold`}
        onClick={onSubmit}
      >
        {isCreating ? 'Creating' : 'Create'}
      </button>
    </div>
  );
};

export default CreateContact;
